import script from "./home-mhsh.vue?vue&type=script&setup=true&lang=js"
export * from "./home-mhsh.vue?vue&type=script&setup=true&lang=js"

import "./home-mhsh.vue?vue&type=style&index=0&id=0705ccea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0705ccea"]])

export default __exports__